import { useQuery } from "@tanstack/react-query"
import { conversationSupportEntitiesQuery } from "../lib/conversationSupportEntitiesQuery"

export function useConversationSupportEntitiesQuery(
  ...args: Parameters<typeof conversationSupportEntitiesQuery>
) {
  return useQuery(conversationSupportEntitiesQuery(...args))
}
